import { Section, SectionTitle } from '@presentation/components';
import { PLACEHOLDER_IMAGE } from '@presentation/constants';
import { useRouter } from '@application/utils';
import { ProfessionalTypeEnum } from '@gql/graphql';
import type { FC } from 'react';
import * as Styled from '../../styled';
import type { ProHeaderProps } from './types';

export const ProHeader: FC<ProHeaderProps> = (props) => {
  const { pro } = props;

  const { translate } = useRouter();
  const title = translate('common.modals.whatsApp.title');

  return (
    <Section centerChildren>
      <SectionTitle>{title}</SectionTitle>
      <Styled.ProContactInfosTitleWrapper>
        <Styled.ProContactInfosImg src={pro?.avatar ?? PLACEHOLDER_IMAGE} alt="pro-avatar-image" />
        <div>
          <h5>{pro?.title}</h5>
          <Styled.ProContactInfosType>
            {translate(`enum.proType.${pro?.type ?? ProfessionalTypeEnum.GROOMER}`)}
          </Styled.ProContactInfosType>
        </div>
      </Styled.ProContactInfosTitleWrapper>
    </Section>
  );
};
